<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'table-filler',
  props: {
    rows: {
      type: Array,
      nullable: true,
    },
    max: {
      type: Number,
      required: true,
    },
    textSize: {
      type: String,
      default: '!text-sm',
    },
  },
});
</script>

<template>
  <template v-if="!rows || rows?.length < max">
    <tr v-for="i of max - (rows?.length || 0)" @click="$emit('click', i)">
      <td colspan="1000" :class="{ [`${textSize}`]: true }">&nbsp;</td>
    </tr>
  </template>
</template>

<style scoped lang="scss"></style>
